var map = {
	"./editorBaseApi": 32,
	"./editorBaseApi.js": 32,
	"./editorSimpleWorker": 22,
	"./editorSimpleWorker.js": 22,
	"./editorWorker": 82,
	"./editorWorker.js": 82,
	"./editorWorkerHost": 43,
	"./editorWorkerHost.js": 43,
	"./findSectionHeaders": 74,
	"./findSectionHeaders.js": 74,
	"./getIconClasses": 84,
	"./getIconClasses.js": 84,
	"./languageFeatureDebounce": 95,
	"./languageFeatureDebounce.js": 95,
	"./languageFeatures": 103,
	"./languageFeatures.js": 103,
	"./languageFeaturesService": 104,
	"./languageFeaturesService.js": 104,
	"./languageService": 108,
	"./languageService.js": 108,
	"./languagesAssociations": 110,
	"./languagesAssociations.js": 110,
	"./languagesRegistry": 109,
	"./languagesRegistry.js": 109,
	"./markerDecorations": 122,
	"./markerDecorations.js": 122,
	"./markerDecorationsService": 123,
	"./markerDecorationsService.js": 123,
	"./model": 141,
	"./model.js": 141,
	"./modelService": 143,
	"./modelService.js": 143,
	"./resolverService": 204,
	"./resolverService.js": 204,
	"./semanticTokensDto": 205,
	"./semanticTokensDto.js": 205,
	"./semanticTokensProviderStyling": 206,
	"./semanticTokensProviderStyling.js": 206,
	"./semanticTokensStyling": 208,
	"./semanticTokensStyling.js": 208,
	"./semanticTokensStylingService": 209,
	"./semanticTokensStylingService.js": 209,
	"./textModelSync/textModelSync.impl": 76,
	"./textModelSync/textModelSync.impl.js": 76,
	"./textModelSync/textModelSync.protocol": 210,
	"./textModelSync/textModelSync.protocol.js": 210,
	"./textResourceConfiguration": 203,
	"./textResourceConfiguration.js": 203,
	"./treeSitterParserService": 197,
	"./treeSitterParserService.js": 197,
	"./treeViewsDnd": 211,
	"./treeViewsDnd.js": 211,
	"./treeViewsDndService": 212,
	"./treeViewsDndService.js": 212,
	"./unicodeTextModelHighlighter": 44,
	"./unicodeTextModelHighlighter.js": 44
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;